import { render, staticRenderFns } from "./ExceptionPage.vue?vue&type=template&id=c295b4d2"
import script from "./ExceptionPage.vue?vue&type=script&lang=js"
export * from "./ExceptionPage.vue?vue&type=script&lang=js"
import style0 from "./ExceptionPage.vue?vue&type=style&index=0&id=c295b4d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports